import { type FC, useEffect } from 'react';

import { setRollPower } from '@/redux/reducers/diceGameReducer';
import { useAppDispatch, useAppSelector } from '@/redux/store';

import RollPowerItem from './RollPowerItem';

interface RollPowerProps {
  energyCount?: number;
  diceCount?: number;
}

const RollPower: FC<RollPowerProps> = ({ diceCount, energyCount }) => {
  const multiplier = useAppSelector((state) => state.diceGame.rollPower);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const minValue = Math.min(energyCount ?? 0, diceCount ?? 0);

    if (multiplier > minValue) {
      const values = [5, 2, 1] as const;
      const newMultiplier = values.find((value) => value <= minValue) ?? 1;
      dispatch(setRollPower(newMultiplier));
    }
  }, [multiplier, energyCount, diceCount]);

  return (
    <div className="grid grid-cols-3 rounded-full bg-surface h-8">
      {[1, 2, 5].map((value) => (
        <RollPowerItem
          disabled={
            !!(typeof diceCount !== 'undefined' && diceCount < value) ||
            !!(typeof energyCount !== 'undefined' && energyCount < value)
          }
          key={value}
          value={value}
          isActive={multiplier === value}
        />
      ))}
    </div>
  );
};

export default RollPower;
